export function NewBadge() {
  return (
    <span className="ml-2 inline-flex items-center rounded bg-primary px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-primary-foreground shadow-beam-sm">
      New
    </span>
  );
}
